import { render, staticRenderFns } from "./bannerAdmin.vue?vue&type=template&id=79abb33e"
import script from "./bannerAdmin.vue?vue&type=script&lang=js"
export * from "./bannerAdmin.vue?vue&type=script&lang=js"
import style0 from "./bannerAdmin.vue?vue&type=style&index=0&id=79abb33e&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports